// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3IlnY","productName":"Table_productName__2uWdl"};